// extracted by mini-css-extract-plugin
export default {"title":"EmptyCardState_title__54X25","subtitle":"EmptyCardState_subtitle__ckiIp","button":"EmptyCardState_button__15o5P","icon":"EmptyCardState_icon__sgBWm"};